import { ICountryDetail } from '../api/account/country';

/**
 * Extracts the dial code from a formatted country key string.
 *
 * @param key - Formatted string in the format `${optionDialCode}_${country}_${countryCode}`
 * @returns The dial code portion of the input key
 *
 * @example
 * ```typescript
 * getDialCodeFromCountryKey("+65_Singapore_SG") // returns "+65"
 * getDialCodeFromCountryKey("+1_United States_US") // returns "+1"
 * ```
 */
export const getDialCodeFromCountryKey = (key?: string): string => {
  if (!key) {
    return '';
  }

  return key.split('_')[0];
};

/**
 * Formats a country key string based on the country detail object.
 *
 * The format is `${dialCode}_${country}_${countryCode}`.
 */
export const setCountryKeyString = (countryDetail?: ICountryDetail): string => {
  if (!countryDetail) {
    return '';
  }

  const { dialCode, country, countryCode } = countryDetail;

  return `${dialCode}_${country}_${countryCode}`;
};

/**
 * If the country has a country code, the label is in the format `${country} - ${countryCode} (${dialCode})`.
 * Otherwise, the label is in the format `${country} (${dialCode})`.
 *
 * @param countryDetail - Optional country detail object.
 */
export const getCountryDialCodeLabel = (countryDetail?: ICountryDetail): string => {
  if (!countryDetail) {
    return '';
  }

  const { dialCode, country, countryCode } = countryDetail;

  return countryCode ? `${country} - ${countryCode} (${dialCode})` : `${country} (${dialCode})`;
};

export const getCountryWithCodeLabel = (countryDetails?: ICountryDetail): string => {
  if (!countryDetails) {
    return '';
  }

  const { country, countryCode } = countryDetails;

  return countryCode ? `${country} - ${countryCode}` : `${country}`;
};
